import React, { RefObject } from 'react';
import { useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { CustomFieldButtons } from '@teetsh/app/src/components/CustomFields/CustomFieldButtons';
import { useEventCustomFieldDefinitionsContext } from 'containers/App/context/EventCustomFieldDefinitionsContext/EventCustomFieldDefinitionsProvider';

interface Props {
  formFieldName: string;
  inputRefs?: RefObject<HTMLInputElement[]>;
  enableEdit: boolean;
  onAddToSeanceCallback?: () => void;
}

export function CustomFieldsButtons({
  formFieldName,
  inputRefs,
  enableEdit,
  onAddToSeanceCallback,
}: Props) {
  const field = useField(formFieldName);
  const {
    definitions: eventCustomFieldDefinitions,
    deleteDefinition: onDeleteDefinition,
    updateDefinition: onUpdateDefinition,
  } = useEventCustomFieldDefinitionsContext();

  const { t } = useTranslation(['cahierJournal']);
  const {
    input: { onChange, value },
  } = field;

  return (
    <CustomFieldButtons
      definitions={eventCustomFieldDefinitions}
      values={value || []}
      onChange={onChange}
      onUpdateDefinition={onUpdateDefinition}
      onDeleteDefinition={onDeleteDefinition}
      enableEdit={enableEdit}
      inputRefs={inputRefs}
      onAddCallback={onAddToSeanceCallback}
      translations={{
        noName: t('cahierJournal:seance.modal.customFieldWithNoName'),
      }}
    />
  );
}
